<template>
  <div class="sso-config-modal-copy-field">
    <BittsFormLabel :label="{ title, helpText }" :decorative="true" />
    <div class="sso-config-modal-copy-field__row">
      <span class="sso-config-modal-copy-field__value">
        {{ value }}
      </span>
      <button
        type="button"
        class="sso-config-modal-copy-field__copy"
        :aria-label="`Copy ${title}`"
        @click="handleCopy"
      >
        <FontAwesomeIcon
          :icon="hasCopied ? ['fas', 'check'] : ['fak', 'copy']"
          :style="{ height: '14px', width: '14px', color: 'currentColor' }"
        />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsFormLabel } from '@crossbeam/bitts';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ref } from 'vue';

import { copyToClipBoard } from '@/utils';

const props = withDefaults(
  defineProps<{
    title: string;
    helpText?: string;
    value?: string;
  }>(),
  { helpText: '', value: '' },
);

const hasCopied = ref(false);

async function handleCopy() {
  await copyToClipBoard(props.value);
  hasCopied.value = true;
  setTimeout(() => {
    hasCopied.value = false;
  }, 2000);
}
</script>

<style scoped lang="pcss">
@reference "../../../../css/theme.css";
.sso-config-modal-copy-field__row {
  @apply flex items-center justify-between gap-12;
}

.sso-config-modal-copy-field__value {
  @apply text-sm text-neutral-text-strong break-all;
}

.sso-config-modal-copy-field__copy {
  @apply shrink-0 text-neutral-text-button cursor-pointer;
}
</style>
